// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1D8H3","footer":"ModalUpdate_footer__Kmcmi"};